import type { ComponentPropsWithoutRef } from "react";

type ShareArrowIconProps = ComponentPropsWithoutRef<"svg"> & {
  size?: number;
};

export default function ShareArrowIcon({ size = 18, width, height, ...props }: ShareArrowIconProps) {
  return (
    <svg viewBox="0 0 1102 1024" width={width ?? size} height={height ?? size} aria-hidden="true" {...props}>
      <path
        d="M365.646769 980.046769a16.147692 16.147692 0 0 1-4.988718 1.864205 37.415385 37.415385 0 0 1-46.998974-22.422974c-61.833846-161.398154-65.536-301.948718-12.104205-418.185846a468.755692 468.755692 0 0 1 199.02359-208.134564l19.350974-11.158975-55.506051-108.911589c-21.976615-43.139282 12.445538-72.572718 44.058256-62.227693l371.633231 125.453129a68.581744 68.581744 0 0 1 47.182769 96.492307L813.42359 737.673846a41.353846 41.353846 0 0 1-50.569846 29.853539 41.878974 41.878974 0 0 1-27.280411-22.633026l-59.392-116.578462-24.576 12.524308c-89.45559 45.581128-243.029333 146.353231-266.89641 310.298257a33.083077 33.083077 0 0 1-18.825846 28.882051l-0.262564 0.026256z"
        fill="currentColor"
      />
    </svg>
  );
}
